/**
 * A provider may refer to a capture either by the payload's captureId or by the
 * function-call id that produced it. Both references mean the binary has
 * already been consumed and can be compacted out of subsequent model requests.
 */
export function captureReferenceWasReviewed(
  reviewedReferences: ReadonlySet<string>,
  captureId: string,
  captureToolUseId: string,
): boolean {
  return reviewedReferences.has(captureId) || reviewedReferences.has(captureToolUseId);
}

/**
 * A focused capture is evidence only for the elements it actually covered.
 * A verdict about another element must not erase a valid approval from an
 * earlier capture; if that element has never been approved, it merely remains
 * pending until a suitable image is produced.
 */
export function uncoveredVisualVerdictDisposition(
  wasPreviouslyApproved: boolean,
  coveredByCurrentCapture: boolean,
): "evaluate" | "preserve-approval" | "remain-pending" {
  if (coveredByCurrentCapture) return "evaluate";
  return wasPreviouslyApproved ? "preserve-approval" : "remain-pending";
}
